<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper faq-page bg-white-imp">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <h1 class="title has-text-black">Faqs</h1>
        </div>
      </app-header>
      
      <main class="content-wrapper bg-white-imp" v-if="!loaded">
          <loading />
      </main>

      <main class="content-wrapper bg-white-imp" v-else>

        <div class="has-text-centered no-faqs" v-if="loaded && message">
          <p>{{ message }}</p>
        </div>

        <section v-else class="mt30 mb30">
          <div class="container">
            <div class="columns justify-content-center">
              <div class="column is-12-tablet has-text-centered">
                <section class="accordions body-text-dark" v-bind:key="'faq_'+index" v-for="(faq,index) in faqs">
                  <article :class="'accordion'+ (faq.active ? ' is-active' : '')  ">
                    <div class="accordion-header toggle" @click="toggelThis(index)">
                      <p class="is-size-16px"><span class="qn">{{ index + 1 }}.</span> {{ faq.question }}</p>
                      <button class="toggle" aria-label="toggle"></button>
                    </div>
                    <div class="accordion-body">
                      <div class="accordion-content pt0">
                      <div class="is-size-14" v-if="faq.type == 'default'">
                        <div class="has-text-dark has-text-left mb-5" v-bind:key="'ans_'+index" v-for="(ans, index) in faq.answers">
                          {{ ans }}
                        </div>
                      </div>
                      <div class="is-size-14" v-if="faq.type == 'faqs'">
                        <div class="has-text-dark has-text-left mb-5" v-html="faq.answer">
                        </div>
                      </div>
                      </div>
                    </div>
                  </article>
                </section>

              </div>
            </div>
          </div>
        </section>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BusinessLoyalityApis from '@/Components/Controllers/BusinessLoyalityApis';
import BusinerssProfileApis from '@/Components/Controllers/BusinerssProfileApis';
export default {
  name: 'Faqs',
  data() {
    return {
      loaded: false,
      message: '',
      faqs: [],
    };
  },

  computed: {
     ...mapGetters({
      vg_selectedStore: "location/selected", 
      vg_businessProfile: "businessprofile/detail",
      vg_businessLoyalityProgram: "businessprofile/businessLoyality",
    })
  },

  async mounted() {
    const self = this;
    await BusinerssProfileApis.fetchBusinessProfile(this.$route.params.business_slug);

    if( !_.isEmpty(this.vg_businessLoyalityProgram) && this.vg_businessLoyalityProgram.id && this.vg_businessLoyalityProgram.is_active) {
      if(this.vg_businessLoyalityProgram.tokens && (this.vg_businessLoyalityProgram.tokens.length > 0 ) ){
        this.loaded = false;
        let faqDefaultApi = BusinessLoyalityApis.fetchBusinessLoyalityFaqsDefault(this.vg_businessLoyalityProgram.tokens[0].token);
        let faqsApi = BusinessLoyalityApis.fetchBusinessLoyalityFaqs(this.vg_businessLoyalityProgram.tokens[0].token);
        Promise.all([faqDefaultApi, faqsApi]).then(function (res) {
          let count = 0;
          // Handle the default one first 
          if(res[0].status == 200) {
            let unwantedKeys = ['api_version', 'msg'];
            for(let key in res[0].data){
              //not the keys
              if(unwantedKeys.indexOf(key) == -1){
                let eachCat = res[0].data[key];
                eachCat.forEach(item => {
                  count++;
                  item.type = 'default';
                  item.active = count == 1 ? true : false;
                  self.faqs.push(item)
                })
              }
            }
          }

          // Lets handle faqs
          if(res[1].status == 200){
            res[1].data.payload.forEach(catFaq => {
              let categoryFaq = catFaq.faqs;
              if(categoryFaq.length > 0){
                categoryFaq.forEach(faqList => {
                  count++;
                  faqList.type = 'faqs';
                  faqList.active = count == 1 ? true : false;
                  self.faqs.push(faqList)
                })
              }
            })
          }
          self.loaded = true;
        })
      }
    } else {
      this.loaded = true;
      this.message = 'Sorry no faqs found. Loyalty program is currently inactive.';
    }
  },

  methods: {
    toggelThis(index) {
      this.faqs[index].active = !this.faqs[index].active;
      this.faqs.map( (item, itemIndex) => {
        if(index != itemIndex){
          item.active = false;
        } 
      })
    },
  },
};
</script>

<style scoped>
.no-faqs {
    width: 100%;
    height: 100%;
    display: flex;
    height: 52vh;
    justify-content: center;
    align-items: center;
}
</style>